module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dataTimeSpan":"target period"},"ja":{"dataTimeSpan":"対象期間"},"zh-hant":{"dataTimeSpan":"目標期間"},"zh-hans":{"dataTimeSpan":"目标期间"}}')
  delete Component.options._Ctor
}
